<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-10 10:17:47
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-10 10:17:59
 * @FilePath: \YunYin_admin\src\views\Village\Resources\Index.vue
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "VillageResources",
};
</script>